import React, { useEffect, useMemo, useState } from 'react';
import ReactDOM from 'react-dom';

const PortalProfileSaveButton: React.FC<{ containerClass: string; children: any; disabled?: boolean }> = ({
  containerClass,
  children,
  disabled = false,
}) => {
  const [element, setElement] = useState<Element | null>(null);
  useEffect(() => {
    setElement(document.querySelector(`${containerClass ? `${containerClass}` : ''}`));
    element?.classList.add('gx-d-none');
    return () => {
      if (element) {
        element.removeChild(children);
      }
    };
  }, []);

  const ButtonComponent = useMemo(() => (element ? ReactDOM.createPortal(children, element) : null), [
    children,
    element,
  ]);
  if (disabled) return children;
  return ButtonComponent;
};

export default React.memo(PortalProfileSaveButton);
